import { render } from "./VerifyPhonePage.vue?vue&type=template&id=ccc4c95e&scoped=true"
import script from "./VerifyPhonePage.vue?vue&type=script&lang=js"
export * from "./VerifyPhonePage.vue?vue&type=script&lang=js"

import "./VerifyPhonePage.vue?vue&type=style&index=0&id=ccc4c95e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc4c95e"]])

export default __exports__